import e from "../../utils/classNames.js";
import { useDialogContext as t } from "./dialogContext.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/dialog/DialogFooter.tsx
var r = (r) => {
	let { className: i = "", children: a, ...o } = r, { isSmallestDialog: s, showXsDialogBorders: c } = t(), l = e("modal-footer", !(!s || c) && "border-top-none padding-top-0", i);
	return /* @__PURE__ */ n("div", {
		...o,
		className: l,
		"aria-label": "dialog footer",
		children: a
	});
};
//#endregion
export { r as default };

//# sourceMappingURL=DialogFooter.js.map